import { Autocomplete, Chip, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

function parseDefaultValue(defaultValue, delimiter) {
  if (!defaultValue) return [];
  if (Array.isArray(defaultValue)) return defaultValue;

  try {
    const parsedValue = JSON.parse(defaultValue);
    if (Array.isArray(parsedValue)) return parsedValue;
  } catch (error) {
    // Fall back to delimiter-based values used by older forms.
  }

  return defaultValue
    .split(delimiter)
    .map((value) => value.trim())
    .filter(Boolean);
}

function FormFreeSoloChipInput({
  name,
  label,
  values,
  sxValues,
  control,
  limitTags = 10,
  defaultValue,
  delimiter = "| ",
  helperText,
  rules,
  onValueSelected = () => {},
  ...rest
}) {
  const preloadedValue = parseDefaultValue(defaultValue, delimiter);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={preloadedValue}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          multiple
          freeSolo
          limitTags={limitTags}
          value={value || []}
          onChange={(event, newValue) => {
            onChange(newValue);
            onValueSelected(newValue);
          }}
          options={values || []}
          style={{ minWidth: "250px" }}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => {
              const { key, ...tagProps } = getTagProps({ index });
              return (
                <Chip
                  key={key}
                  variant="outlined"
                  label={option}
                  {...tagProps}
                  sx={{
                    color: "white",
                    backgroundColor: "#2b324c",
                    border: "1px solid gray",
                    "& .MuiChip-deleteIcon": {
                      color: "white"
                    }
                  }}
                />
              );
            })
          }
          renderInput={(params) => (
            <TextField
              error={!!error}
              helperText={error ? error.message : helperText}
              {...params}
              {...rest}
              sx={sxValues}
              label={label}
            />
          )}
        />
      )}
    />
  );
}

export default FormFreeSoloChipInput;
